import script from "./centralInventory.vue?vue&type=script&setup=true&lang=js"
export * from "./centralInventory.vue?vue&type=script&setup=true&lang=js"

import "./centralInventory.vue?vue&type=style&index=0&id=6d953734&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d953734"]])

export default __exports__